export const PLAYERS_DEFAULTS = {
    canPlayThrough: false,
}
